<section style="
background-image: url('assets/hd-1.webp');
background-size: cover;
background-position: center center;
margin: 0;
padding: 0;
position: relative;
overflow: hidden;
">
    <div class="container">
        <div class="row">
            <div class="col-lg-7" style="margin-top:100px; margin-bottom:200px">
                <h3 class="text-secondary" style="text-transform: uppercase;
                font-weight: 800;
                font-size: 21px;
              ">let us develop it for you</h3>
                <div style="margin-top: 30px; margin-bottom: 30px;">
                    <h1 class="text-uppercase text-primary" style="font-weight: 800;font-size: 45px;
                    line-height: 65px;">Computer programming services designed for your needs</h1>
                </div>
                <p style="color: rgb(64, 77, 96);">
                    We're a technology company that's part of the "new economy." We combine our technical expertise in
                    computer programming, custom software design and Internet services with other areas of business
                    services to help clients develop new information technologies.
                </p>
                <div style="padding-top:30px">
                    <button type="button" (click)="navigate('/services')"
                        class="btn btn-secondary btn-sm border-secondary" style="min-width: 215px;">What Do We
                        Build?</button>
                    <button type="button" (click)="navigate('/contact')" class="btn btn-outline-primary btn-sm"
                        style="min-width: 215px;">Request a quote</button>
                </div>
            </div>
            <div class="col-lg-5 hidden-md">
                <img class="fade-bottom" src="assets/man-3.webp" width="401" height="780" style="position: relative;
                animation-duration: 1000ms;
                transition-timing-function: ease;
                transition-delay: 0ms; margin-bottom: -30px; margin-top:30px" alt="" />
            </div>
        </div>
    </div>
</section>